<div class="dropdown" v-click-outside="handleFocusOut" :class="classStyle">
  <button id="btn" @click.stop="handleFocusOn" methods  :disabled="disable" :class="{'disable' : disable}" >
    <div v-if="text!=''" id="title"><span id="title">{{text}}</span></div>
    <!-- <img v-else-if="icon!=''" id="img" :src="iconSrc"> -->
    <iCon v-else-if="icon!=''" id="img" class="svg" :iconClass="icon"></iCon>
  </button>
  <FocusLoop :is-visible="state.isOpen">
    <div class="popup" :class="[state.isOpen?'show':'noshow']"
      :style="'margin-left:'+[popup_x]+'px;margin-top:'+[popup_y]+'px'">
      <a href="javascript:;" class="option-item" v-for="(value, index) in data_up" @click.stop="onClick({value}, index)" 
        :class="{active:index === active}">
        {{typeof value == 'string' ?  value : value.name}}
        <i class="icon-block" v-if="theme === '2' || theme === '4'">
          <iCon class="icon" iconClass="icon-check"></iCon>
        </i>
      </a>
      <div v-if="data_down.length>0" class="line"></div>
      <button class="option-item" v-for="(value, index) in data_down"  
        @click.stop="onClick({value}, index)">{{value}}</button>
    </div>
  </FocusLoop>
</div>